import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {User} from 'classes/user';
import {UserListRepository} from '../repositories/user-list.repository';
import { Group } from 'shared/models/target-groups/group';
import { TargetGroup } from 'shared/models/target-groups/target-group';

@Injectable()
export class UserListService {

  constructor(private userListRepository: UserListRepository) { }

  public getUsers(): Observable<Array<User>> {
    return this.userListRepository.getUsers();
  }

  public deleteUser(id: number): Observable<Response> {
    return this.userListRepository.deleteUser(id);
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.userListRepository.getAllTargetGroups();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-list/services/user-list.service.ts